// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 16/11/2023
 */


.AdditionalDetailsStep_container__jIikd{
    margin-top: 2rem;
}

.AdditionalDetailsStep_paper__fDVcJ {
    padding: 1.5rem 0;
    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
}

.AdditionalDetailsStep_topic__Hi-kO {
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    margin: 0 1.5rem 1.5rem 2.38rem;
}

.AdditionalDetailsStep_inputContainer__TPcQx {
    margin: 1.5rem 0.1rem;
}

.AdditionalDetailsStep_subTitle__K4xAp {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    margin-left: 2.28rem;
}

.AdditionalDetailsStep_textInputContainer__q83QF {
    margin: 1.5rem 2.38rem;
}

.AdditionalDetailsStep_textSubTitle__gFYHc {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
}

.AdditionalDetailsStep_textInput__kQsaV {
    border-radius: 0.5rem;
    background: #FFF;
    box-shadow: 2px 2px 50px 2px #657FAD1A;
    margin-top: 0.5rem;
}

.AdditionalDetailsStep_selectionContainer__mkMaa {
    margin-left: 2.28rem;
    display: flex;
    margin-top: 0.5rem;
    overflow: scroll;
    overflow-y: auto;
}

.AdditionalDetailsStep_selectionContainer__mkMaa::-webkit-scrollbar {
    display: none;
}

.AdditionalDetailsStep_selectionContainer__mkMaa :first-child {
    margin-left: 0;
}

.AdditionalDetailsStep_numberButton__asoSS {
    border-radius: 100%;
    border: 1px #5A9BD8 solid;
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 0.7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.125rem;
    font-weight: 400;
    cursor: pointer;
}

.AdditionalDetailsStep_numberButtonSelected__wUJ-i {
    background-color: #5a9bd8cb;
}

.AdditionalDetailsStep_option__asKS5 {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 2.5rem;
    width: 5rem;
    border-radius: 0.5rem;
    border: 1px #5A9BD8 solid;
    font-size: 1rem;
    font-weight: 400;
    margin: 0 2rem;
    cursor: pointer;
}

/* for mobile */
@media (max-width: 770px) {
    .AdditionalDetailsStep_paper__fDVcJ {
        background: #FFF;
    }
    .AdditionalDetailsStep_topic__Hi-kO {
        margin: 0 1.5rem 2rem 0.5rem;
        font-size: 1.5rem;
        font-weight: 600;
    }
    .AdditionalDetailsStep_subTitle__K4xAp {
        font-size: 1rem;
    }
    .AdditionalDetailsStep_numberButton__asoSS {
        height: 2rem;
        width: 2rem;
        font-size: 1rem;
        margin: 0 0.2rem;
    }
    .AdditionalDetailsStep_inputContainer__TPcQx {
        margin: 2rem 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/AdditionalDetailsStep.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;AAGF;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gGAAgG;AACpG;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,eAAe;AACf;IACI;QACI,gBAAgB;IACpB;IACA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 16/11/2023\r\n */\r\n\r\n\r\n.container{\r\n    margin-top: 2rem;\r\n}\r\n\r\n.paper {\r\n    padding: 1.5rem 0;\r\n    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n}\r\n\r\n.topic {\r\n    font-size: 1.6rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin: 0 1.5rem 1.5rem 2.38rem;\r\n}\r\n\r\n.inputContainer {\r\n    margin: 1.5rem 0.1rem;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    margin-left: 2.28rem;\r\n}\r\n\r\n.textInputContainer {\r\n    margin: 1.5rem 2.38rem;\r\n}\r\n\r\n.textSubTitle {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n}\r\n\r\n.textInput {\r\n    border-radius: 0.5rem;\r\n    background: #FFF;\r\n    box-shadow: 2px 2px 50px 2px #657FAD1A;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.selectionContainer {\r\n    margin-left: 2.28rem;\r\n    display: flex;\r\n    margin-top: 0.5rem;\r\n    overflow: scroll;\r\n    overflow-y: auto;\r\n}\r\n\r\n.selectionContainer::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.selectionContainer :first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.numberButton {\r\n    border-radius: 100%;\r\n    border: 1px #5A9BD8 solid;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    margin: 0 0.7rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 1.125rem;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n}\r\n\r\n.numberButtonSelected {\r\n    background-color: #5a9bd8cb;\r\n}\r\n\r\n.option {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 2.5rem;\r\n    width: 5rem;\r\n    border-radius: 0.5rem;\r\n    border: 1px #5A9BD8 solid;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    margin: 0 2rem;\r\n    cursor: pointer;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .paper {\r\n        background: #FFF;\r\n    }\r\n    .topic {\r\n        margin: 0 1.5rem 2rem 0.5rem;\r\n        font-size: 1.5rem;\r\n        font-weight: 600;\r\n    }\r\n    .subTitle {\r\n        font-size: 1rem;\r\n    }\r\n    .numberButton {\r\n        height: 2rem;\r\n        width: 2rem;\r\n        font-size: 1rem;\r\n        margin: 0 0.2rem;\r\n    }\r\n    .inputContainer {\r\n        margin: 2rem 0.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AdditionalDetailsStep_container__jIikd`,
	"paper": `AdditionalDetailsStep_paper__fDVcJ`,
	"topic": `AdditionalDetailsStep_topic__Hi-kO`,
	"inputContainer": `AdditionalDetailsStep_inputContainer__TPcQx`,
	"subTitle": `AdditionalDetailsStep_subTitle__K4xAp`,
	"textInputContainer": `AdditionalDetailsStep_textInputContainer__q83QF`,
	"textSubTitle": `AdditionalDetailsStep_textSubTitle__gFYHc`,
	"textInput": `AdditionalDetailsStep_textInput__kQsaV`,
	"selectionContainer": `AdditionalDetailsStep_selectionContainer__mkMaa`,
	"numberButton": `AdditionalDetailsStep_numberButton__asoSS`,
	"numberButtonSelected": `AdditionalDetailsStep_numberButtonSelected__wUJ-i`,
	"option": `AdditionalDetailsStep_option__asKS5`
};
export default ___CSS_LOADER_EXPORT___;
